import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import { Alert, Button, Stack, Text } from '@mantine/core'
import CommentPosts from './CommentPosts'

export default function TaskChat({ task, viewId }) {
  const { t } = useTranslation()
  const [data, setData] = useState(null)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const generation = useRef(0)
  useEffect(() => {
    generation.current += 1; setData(null); setError(''); setBusy(false)
    return () => { generation.current += 1 }
  }, [task.id, viewId])
  async function loadChat() {
    const current = ++generation.current
    setBusy(true); setError('')
    try {
      const response = await fetch(`/planner/task_chat?view_id=${viewId}&task_id=${encodeURIComponent(task.id)}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      if (response.redirected) throw new Error(t("Meld opnieuw aan met Microsoft."))
      const result = await response.json()
      if (!response.ok) throw new Error(result.error || t("Taakchat ophalen is niet gelukt."))
      if (generation.current === current) setData(result)
    } catch (e) { if (generation.current === current) setError(e.message) }
    finally { if (generation.current === current) setBusy(false) }
  }
  return <Stack gap="sm">
    <Text size="sm" fw={650}>{t("Taakchat")}</Text>
    <Alert color="yellow">{t("Deze functie gebruikt de Microsoft-bèta-API. Microsoft ondersteunt deze API niet voor productie en kan hem wijzigen.")}</Alert>
    <Button variant="light" size="sm" loading={busy} onClick={loadChat}>{data ? t("Taakchat vernieuwen (bèta)") : t("Taakchat testen (Microsoft bèta)")}</Button>
    {error && <Alert color="red">{t(error)}</Alert>}
    {data && <CommentPosts posts={data.posts}/>}
  </Stack>
}
